// extracted by mini-css-extract-plugin
export default {"SpacingSM":"10px","list":"G3a5b23 G82d927 G2bc9f1","listItem":"Gcd5e88 G6eac61 G01f208 Gb4bac3","textBold":"Gd9603e Gd6846a"};